var _defs, _line, _path, _path2, _polygon, _polygon2, _polygon3, _polygon4, _polygon5, _polygon6, _polygon7, _polygon8, _polygon9, _polygon10, _polygon11, _polygon12, _polygon13, _polygon14, _polygon15, _polygon16, _polygon17, _polygon18, _polygon19, _polygon20, _polygon21, _polygon22, _polygon23, _polygon24;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMethodicalLogo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 2849.89 3259",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:none;stroke-width:0.1px;}.cls-1,.cls-10,.cls-11,.cls-12,.cls-13,.cls-14,.cls-15,.cls-16,.cls-17,.cls-18,.cls-19,.cls-2,.cls-20,.cls-21,.cls-22,.cls-23,.cls-24,.cls-25,.cls-26,.cls-27,.cls-3,.cls-4,.cls-5,.cls-6,.cls-7,.cls-8,.cls-9{stroke:#231f20;stroke-miterlimit:10;}.cls-2,.cls-3{fill:#c1bac7;}.cls-2{stroke-width:13px;}.cls-3{stroke-width:14px;}.cls-4{fill:#c1b9c4;}.cls-10,.cls-11,.cls-12,.cls-13,.cls-14,.cls-15,.cls-16,.cls-17,.cls-18,.cls-19,.cls-20,.cls-21,.cls-22,.cls-23,.cls-24,.cls-25,.cls-26,.cls-27,.cls-4,.cls-5,.cls-6,.cls-7,.cls-8,.cls-9{stroke-width:6px;}.cls-5{fill:#d5d1dc;}.cls-6{fill:#85758e;}.cls-7{fill:#79c6b6;}.cls-8{fill:#aea4b3;}.cls-9{fill:#978ca0;}.cls-10{fill:#ee9363;}.cls-11{fill:#52a9b0;}.cls-12{fill:#85768d;}.cls-13{fill:#9a8fa3;}.cls-14{fill:#412a52;}.cls-15{fill:#ee9560;}.cls-16{fill:#fad941;}.cls-17{fill:#52a8b4;}.cls-18{fill:#52a9b3;}.cls-19{fill:#84758e;}.cls-20{fill:#87768e;}.cls-21{fill:#412b4f;}.cls-22{fill:#e33945;}.cls-23{fill:#e33a43;}.cls-24{fill:#43a2a9;}.cls-25{fill:#c0b8c6;}.cls-26{fill:#f8d214;}.cls-27{fill:#f8d940;}"))), _line || (_line = /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 776.08,
    y1: 505.25,
    x2: 2849.86,
    y2: 1706.48
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M235.75,1849.56",
    transform: "translate(-371.83 -198.27)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M3345.23,2771.8",
    transform: "translate(-371.83 -198.27)"
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "1418.42 820.59 1418.42 8.13 714.81 414.36 1418.42 820.59"
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-5",
    points: "1421.89 817.66 2125.5 411.43 1421.89 5.2 1421.89 817.66"
  })), _polygon3 || (_polygon3 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "1415.49 3253.8 1415.49 2441.34 711.88 2847.57 1415.49 3253.8"
  })), _polygon4 || (_polygon4 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-7",
    points: "1418.95 3250.87 2122.57 2844.64 1418.95 2438.41 1418.95 3250.87"
  })), _polygon5 || (_polygon5 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-8",
    points: "714.02 1227.83 714.02 415.37 10.4 821.6 714.02 1227.83"
  })), _polygon6 || (_polygon6 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-9",
    points: "710.82 1209.09 7.2 802.86 7.2 1615.32 710.82 1209.09"
  })), _polygon7 || (_polygon7 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-10",
    points: "2125.5 1209.09 1421.89 802.86 1421.89 1615.32 2125.5 1209.09"
  })), _polygon8 || (_polygon8 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-11",
    points: "2832.84 1622.93 2129.23 1216.7 2129.23 2029.16 2832.84 1622.93"
  })), _polygon9 || (_polygon9 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-12",
    points: "707.88 2025.03 4.27 1618.8 4.27 2431.26 707.88 2025.03"
  })), _polygon10 || (_polygon10 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-13",
    points: "6.47 1617.06 710.08 1210.83 710.08 2023.29 6.47 1617.06"
  })), _polygon11 || (_polygon11 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-14",
    points: "1418.16 1617.06 714.54 1210.83 714.54 2023.29 1418.16 1617.06"
  })), _polygon12 || (_polygon12 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-15",
    points: "716.75 1209.09 1420.36 802.86 1420.36 1615.32 716.75 1209.09"
  })), _polygon13 || (_polygon13 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-16",
    points: "1421.15 821.6 2124.77 415.37 2124.77 1227.83 1421.15 821.6"
  })), _polygon14 || (_polygon14 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-17",
    points: "2829.91 2438.87 2126.3 2032.64 2126.3 2845.1 2829.91 2438.87"
  })), _polygon15 || (_polygon15 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-18",
    points: "2128.5 2030.9 2832.11 1624.67 2832.11 2437.13 2128.5 2030.9"
  })), _polygon16 || (_polygon16 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-19",
    points: "1415.22 2435.93 711.61 2029.7 711.61 2842.17 1415.22 2435.93"
  })), _polygon17 || (_polygon17 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-20",
    points: "709.61 2837.76 709.61 2025.3 6 2431.53 709.61 2837.76"
  })), _polygon18 || (_polygon18 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-21",
    points: "713.81 2027.96 1417.42 1621.73 1417.42 2434.2 713.81 2027.96"
  })), _polygon19 || (_polygon19 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-22",
    points: "2125.5 2027.96 1421.89 1621.73 1421.89 2434.2 2125.5 2027.96"
  })), _polygon20 || (_polygon20 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-23",
    points: "1424.09 1620 2127.7 1213.76 2127.7 2026.23 1424.09 1620"
  })), _polygon21 || (_polygon21 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-24",
    points: "1421.15 2438.87 2124.77 2032.64 2124.77 2845.1 1421.15 2438.87"
  })), _polygon22 || (_polygon22 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-25",
    points: "714.81 1227.83 714.81 415.37 1418.42 821.6 714.81 1227.83"
  })), _polygon23 || (_polygon23 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-26",
    points: "2128.5 1212.03 2832.11 805.79 2832.11 1618.26 2128.5 1212.03"
  })), _polygon24 || (_polygon24 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-27",
    points: "2126.56 1213.22 2126.56 400.76 2830.17 806.99 2126.56 1213.22"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMethodicalLogo);
export default __webpack_public_path__ + "static/media/methodical-logo.13cf5a8159382f22c62218bf1a86be4f.svg";
export { ForwardRef as ReactComponent };